import DroppedPinIcon from "../components/DroppedPinIcon";
import FreeIcon from "../components/FreeIcon";
import Logo from "../components/Logo";
import ShieldElectricIcon from "../components/ShieldElectricIcon";
import Spec from "../components/Spec";
import EventCountdown from "../components/EventCountdown";
import EventDate from "../components/EventDate";
import Hero from "../components/Hero";
import Organizers from "../components/Organizers";
import ImageCarousel from "../components/ImageCarousel";
import VideoSection from "../sections/VideoSection";
//import Sponsors from "../components/Sponsors";
import ButtonLink from "../components/ButtonLink";
import eventFormatPhoto from "../assets/spiderman.jpeg";
import post_logo from "../assets/spcs_logo.svg"
import video_image from "../assets/palexpo2.jpg"
//import tenable from "../assets/sponsors/tenable-logo.png";
//import vectra_logo from "../assets/sponsors/vectra-logo.png";
//import airlock_logo from "../assets/sponsors/airlock-logo.png";
//import c2sec_logo from "../assets/sponsors/c2sec-logo.png";
//import cribl_logo from "../assets/sponsors/cribl-logo.png";
//import karspersky_logo from "../assets/sponsors/karsperky-logo.png";
//import splunk_logo from "../assets/sponsors/splunk.png";
//import knowbe4_logo from "../assets/sponsors/knowbe4.png";
//import menlo_logo from "../assets/sponsors/menlo-security-logo.png";
//import one_identity_logo from "../assets/sponsors/one-identity.png";
//import microsoft_logo from "../assets/microsoft_logo.png";
//
//import PlanningSection from "../sections/PlanningSection";
//import Agenda from "../components/Agenda";
import ThankYouNote from "../components/ThankYouNote";
/*
import SpeakerSection from "../sections/SpeakerSection";
import Sponsors from "../components/Sponsors";
import infomaniak from "../assets/infomaniak.png";
import pwc_outlined_logo from "../assets/pwc_outlined_logo.png";
import hkta_logo from "../assets/hkta_logo.png";
import sentinel_one from "../assets/sponsors/SentinelOne_Logo_white-purple.png";
import fortinet_logo from "../assets/sponsors/fortinet-logo.png";
import elastic_logo from "../assets/sponsors/elastic-logo-reverse.svg";
import cyberreason from "../assets/sponsors/cyberreason-logo.png";
import threatray from "../assets/sponsors/threatray-logo.png";

import speaker_daniel_kuenzli from "../assets/speakers/daniel-kuenzli.png";
import speaker_thomas_cueni from "../assets/speakers/thomas-cueni.jpg";
import speaker_rene_bodmer from "../assets/speakers/rene-bodmer.png";
import speaker_luca_bertolotto_cipriani from "../assets/speakers/luca-bertolotto.png";
import speaker_fabian_gentinetta from "../assets/speakers/fabian_gentinetta.jpeg";
import speaker_martin_de_jongh from "../assets/speakers/MartinDJ_SentinelOne.png";
import speaker_eric_de_bressing from "../assets/speakers/eric-de-bressing.jpeg";
import speaker_patrick_buchholz from "../assets/speakers/patrick-buchholz.jpg";
import speaker_marcel_zumbuehl from "../assets/speakers/marcel-zumbuehl.png";
import speaker_detlev_narr from "../assets/speakers/detlev-narr.png";
import speaker_unknown from "../assets/speakers/unknown_person.jpg";
*/


const eventDate: Date = new Date(2026, 5, 9, 12, 45); // 9 june 2026

export default function GenevEventTab() {
  return (
    <div className="container">
      <ThankYouNote />
      <section>
        <div style={styles.logoContainer}>
          <Logo width="auto" height="102px" />
        </div>
        <EventDate date={eventDate} />
        <Hero
          title="Genev’Hack"
          subtitle="Taking cybersecurity seriously, but not ourselves<br><br>Exciting input presentations and good networking opportunities await you - new in Geneva, Zurich, Lugano and also in Luxembourg. Aimed at Cybersecurity Experts, IT enthusiasts and Students , we offer presentations in different tracks and a Networking Apero in the evening"
          titleStyle={styles.title}
          subtitleStyle={styles.subtitle}
        />
        <div className="specs-container">
          <Spec icon={<DroppedPinIcon />} title="Geneva Palexpo" url="https://maps.app.goo.gl/xdJ5JZPTePdP5TPs6"/>
          <Spec icon={<FreeIcon />} title="100% Free" />
          <Spec icon={<ShieldElectricIcon />} title="100% cybersecurity" />
        </div>
        <EventCountdown date={eventDate} />
      </section>
      <section>
        <ButtonLink
          /*</section>href="https://infomaniak.events/en-ch/conferences/genevhack-2025/90096f3d-505f-44b2-bbe2-192861842b67/event/1370148"*/
          href=""
          newTab={false}
          style={{ maxWidth: "161px" }}
        >
          Save the date
        </ButtonLink>
      </section>
      {/*
      <section>
        <AboutTheEvent mapUrl="./palexpo-plan.pdf"/>
      </section>
      */}
      {/*
      <section>
        <EventFormat imageSrc={eventFormatPhoto}/>
      </section>
      */}
      {/*
      <section>
        <Agenda
          headers={['', 'Track 1 (Room Delta)', 'Track 2 (Room Gamma)']}
          agenda={[
            { time: "13:00", description1: "Registration Coffee" },
            { time: "13:30", description1: "Opening Ceremony" },
            { time: "13:40", description1: "Network meets Identity: Modern detection and response for the hybrid world [Fabian Gentinetta, Vectra]", description2: "Post Login: Stopping Lateral Movement with Privileged Access Analytics [Aurélien Hess, Vectra]" },
            { time: "14:10", description1: "Searching or finding? In front of or behind your line(s) of defense? [Detlev Narr, Kaspersky]", description2: "Shadows in the Cloud: Unmasking Advanced Evasion Techniques [Tom McVey, Menlo]" },
            { time: "14:40", description1: "Tenable One: Holistic Exposure Management [Thomas Cueni, Tenable]", description2: "OT Security: Tips & Tricks [Christian Fichera & Raphael Ruf, Swiss Post Cybersecurity]" },
            { time: "15:00", description1: "Networking Break" },
            { time: "15:30", description1: "Human Risk Management based on AI [Paul Nkengue, KnowBe4]", description2: "Capabilities of Modern Security Platforms [Eric de Bressing, Splunk]" },
            { time: "16:00", description1: "One Identity Fabric - Foundation for modern identity management [Eric Parietti, OneIdentity]", description2: "A Modern Approach to Telemetry Data Management [Christoph Dittmann, Cribl]" },
            { time: "16:30", description1: "Beyond Compliance: Building Resilient & Secure Third-Party Ecosystems [Renato Martignoni, C2SEC]", description2: "Threat Hunting Basics [Antony Ancelin, Swiss Post Cybersecurity]" },
            { time: "17:00", description1: "Apero and Networking" },
          ]
          }
        ></Agenda>
      </section>
      */}
      {/*
      <section>
      <PlanningSection
          title=""
          subtitle=""
          displayGrid=""
          planning={[
            {
              time: "11:00 - 13:00",
              title: "Microsoft Security Immersion CTF: Into the Breach",
              description: "In this exciting experience, you'll become a cybersecurity analyst who helps solve and mitigate complex and real-world security threats. Leverage the power of Microsoft 365 Defender and Microsoft Sentinel products to detect sophisticated attacks that compromise the network and span multiple phases of the attack lifecycle.",
              index: 0,
              registerBtnText: 'Register for CTF',
              registerUrl: 'https://infomaniak.events/en-ch/conferences/genevhack-ctf-2025/964c1e5c-3bdc-4e9e-807d-28a135454752/event/1414500',
              logo: microsoft_logo
            }
          ]}
        />
      </section>
      */}
      {/*
      <section>
        {
        <PlanningSection
          title="Details"
          subtitle=""
          displayGrid="grid"
          planning={[
            {
              time: "13:00",
              title: "",
              description: "<h1>Registration & Welcome coffee</h1>",
              index: 0,
            },
            {
              time: "",
              title: "Network meets Identity: Modern detection and response for the hybrid world<br><small>Vectra - Fabian Gentinetta / Christian Borst</small>",
              description: "The modern network has changed. We went remote, and into the cloud. The cloud grew, and became more complex. Today, Active Directory and Entra ID stand at the core of most networks. IT and OT are converging, into one giant attack surface. In this talk, we offer strategic perspectives on how to navigate and secure this new reality.",
              index: 1,
            },
            {
              time: "",
              title: "Post Login: Stopping Lateral Movement with Privileged Access Analytics<br><small>Vectra - Aurélien Hess / Christoph Riese / Fabian Gentinetta</small>",
              description: "Attackers know the complexities of managing account permissions across network, cloud and SaaS apps leave gaps for them to abuse. Privileged accounts are routinely used to steal sensitive information and disrupt operations, without ever needing to run an exploit. Some SOC teams focus on monitoring failed login attempts and unusual user behavior, and lean on multi-factor authentication (MFA) to reduce risk. The truth is, those security measures are just one part of the ATO protection equation. You need a proven way to see and stop account takeover attacks in real time.",
              index: 2,
            },
            {
              time: "",
              title: "Searching or finding? In front of or behind your line(s) of defense?<br><small>Kaspersky - Detlev Narr</small>",
              description: "You probably already have the tools! What rules to write? What data to correlate? How to stay up to date? The presentor answers these questions and more, and showcases how you can use Threat Intelligence to improve your organization's security.",
              index: 3,
            },
            {
              time: "",
              title: "Human Risk Management based on AI<br><small>KnowBe4 - Paul Nkengue </small>",
              description: "This presentation focuses on what is probably the most unpredictable part of the IT security equation: people. From phishing attacks and poor password practices to careless handling of sensitive data, learn how to tackle these issues efficiently and effectively.",
              index: 4,
            },
            {
              time: "",
              title: "Goodbye Purple Team, Hello Purple Bots<br><small>Swiss Post Cybersecurity - Patrick Mkhael & Ralph El-Khoury</small>",
              description: "This talk unveils a fully automated, AI-driven purple teaming framework that simulates real-world APT attacks, evaluates detection capabilities, and enhances security defense, all in real-time.",
              index: 5,
            },
            {
              time: "",
              title: "Tenable One: Holistic Exposure Management<br><small>Tenable - Thomas Cueni</small>",
              description: "Threat actors do not adhere to silos in the security field. They look for vulnerabilities of all kinds to exploit and move laterally through the environment. But the tools organizations rely on to secure their attack surface often focus only on individual technologies - cloud, identities, IT, OT, IoT, applications - and generate an enormous amount of unnecessary data. What's missing is a cross-functional view of the relationships between assets, identities and risks that enable attacks, and more importantly, the impact on the organization, whether in terms of revenue, data sovereignty, compliance or other critical metrics.<br>The Tenable One exposure management platform unifies visibility, insights and actions across the entire attack surface. ",
              index: 6,
            },
            {
              time: "",
              title: "Capabilities of Modern Security Platforms<br><small>Splunk - Jürg Fischer / Eric De Bressing</small>",
              description: "The right tool for the right job: old and new critical capabilities for SecOps & Enterprise Resilience",
              index: 7,
            },
            {
              time: "",
              title: "Beyond Compliance: Building Resilient & Secure Third-Party Ecosystems<br><small>C2SEC - Renato Martignoni</small>",
              description: "Increasing third-party cyberattacks highlight why vendor risk must go beyond compliance and become part of everyday security operations. This session explores how organizations can leverage evolving regulations like DORA to move beyond one-time compliance toward building continuously secure third-party ecosystems.",
              index: 8,
            },
            {
              time: "",
              title: "A Modern Approach to Telemetry Data Management<br><small>Cribl - Sven Eichfuss / Christoph Dittmann</small>",
              description: "The tidal wave of data is rising, asking for a modern approach to managing and utilizing telemetry data. Cribl will highlight the value of providing teams with ownership over their data while ensuring overall governance and security.",
              index: 9,
            },
            {
              time: "",
              title: "Shadows in the Cloud: Unmasking Advanced Evasion Techniques <br><small>Menlo - Tom McVey / Brett Raybould</small>",
              description: "This session exposes the mechanics behind today's most sophisticated cloud-based attacks. Through live demonstrations of credential phishing and HTML smuggling techniques, Menlo Security's experts will dissect how threat actors bypass traditional security controls. Participants will witness firsthand how these attacks unfold and learn the architectural approaches needed to defend against browser based threats",
              index: 10,
            },
            {
              time: "",
              title: "Threat modeling and it's importance<br><small>Post  - Heinz Wittig </small>",
              description: "In the past two years, the Swiss Post team has embarked on the complex journey of implementing Threat Modeling, akin to the journeys of the companions through Middle-earth. Along the way, they faced challenges reminiscent of the trials of Moria and the watchful eye of Sauron, as well as threats and resistance. Through perseverance and collaboration, they overcame these obstacles and learned more about potential security risks and their early identification. Join them on their adventure and discover the key lessons and strategies that have led them to success in the ever-evolving world of cybersecurity",
              index: 11,
            },
            {
              time: "",
              title: "One Identity Fabric - foundation for modern identity management<br><small>OneIdentity - Reto Bachman / Eric Parietti</small>",
              description: "Presentation of an ecosystem that enables organizations to implement authentication and authorization for all identities (including general users, privileged accounts and third parties) across the entire infrastructure.",
              index: 12,
            },
            {
              time: "",
              title: "Tabletop Exercises: Because real Chaos has no pause button<br><small>Swiss Post Cybersecurity - Greg Divorne </small>",
              description: "We’ll break down the real value of cybersecurity table-tops — no simulations, just sharp insights, common pitfalls, and how to make chaos a little more manageable.",
              index: 13,
            },
            {
              time: "",
              title: "OT Security: Tips & Tricks<br><small>Swiss Post Cybersecurity - Christian Fichera & Raphael Ruf</small>",
              description: "OT and IT are different in many ways, and cybersecurity is certainly one of them. Priorities, vulnerabilities and how to remediate them are all key differences between these two worlds.<br>As a pentester, the way you approach assessing IT and OT environments needs to be different too, and the specific knowledge a tester has in the OT world can make the difference between a successful test and a broken OT device.<br>A demo taken from real life pentesting experience will also show how easy it can be to compromise OT environments.",
              index: 14,
            },
            {
              time: "",
              title: "Threat Hunting Basics<br><small>Swiss Post Cybersecurity - Antony Ancelin</small>",
              description: "From Intel to Hunts. Threat hunting isn’t new but this session is a practical reminder of the basics. Learn how to use threat intelligence to build hunting hypotheses, assess visibility gaps, and take action when signs of compromise are foundWe will also discuss common challenges MSSPs face when handling CTI and provide a practical example of using CTI use case.",
              index: 15,
            },
            {
              time: "17:00",
              title: "",
              description: "<h1>Apero and Networking</h1>",
              index: 16,
            }
          ]}
        />
        }

      </section>
      */}
      {<section>
        {/*
        <SpeakerSection
          title="Multiple speakers and experts will be joining us !"
          subtitle="Attendees will leave feeling more connected to a community of builders and to the future of the evolving world of cybersecurity"
          speakers={[
            {
              firstName: "Daniel",
              lastName: "Künzli",
              title: 
                "Senior Security Engineer OT, EMEA",
              description:
                "Using only passive monitoring to detect assets in OT networks has a poor calculation model and is limited in terms of effectiveness and timeliness. However, many organizations still believe that this is the only option as network scanning in OT networks is inherently riskier. We present how active scanning methods can be used safely and effectively in the OT environment. It will also provide some use cases of hybrid scanning scenarios and their benefits in reducing deployment costs and optimizing the time-to-value of the deployed solution.",
              image:
              speaker_daniel_kuenzli,
            },
            {
              firstName: "René",
              lastName: "Bodmer",
              title:
                "Head of B2B Switzerland & Austria",
              description:
                "DFI (Digital Footprint Intelligence) - thanks to dark and deep web intelligence, recognise at an early stage that an attack is imminent - e.g. because company access is offered for auction. Benefit: gain time to harden systems thanks to early warning. Time is of the essence in this area!",
              image:
                speaker_rene_bodmer,
            },
            {
              firstName: "Luca",
              lastName: "Bertolotto Cipriani",
              title: "Regional Cybersecurity Risk Program Manager EMEA & CEE",
              description:
                "In the ever-evolving landscape of cyber threats, Switzerland has witnessed a significant rise in cybercrime and ransomware attacks. This presentation delves into the intricate ecosystem of ransomware operations within the Swiss digital domain, exploring the dynamics between attackers, their methodologies, and the impact on businesses",
              image:
                speaker_luca_bertolotto_cipriani,
            },
            {
              firstName: "Fabian",
              lastName: "Gentinetta",
              title: "",
              description:
                "Identity is central to attacks today. Identity cuts across environments. Boundaries split signal which adds complexity and attackers love complexity.",
              image:
                speaker_fabian_gentinetta,
            },
            {
              firstName: "Eric",
              lastName: "de Bressing",
              title: "Senior Staff Solutions Engineer",
              description:
                "In a fast-evolving cyber threat landscape, quick analysis and response are crucial for organizational security. Security Operations Centers (SOCs) grapple with the challenge of swiftly addressing threats in an environment where attackers constantly devise new strategies. Threat analysis often involves manual review across various tools, capturing secondary artifacts, and synthesizing data for insights and corrective action. This presentation will demonstrate optimizing incident response through an integrated solution and novel approaches to reduce Mean Time to Respond (MTTR) early in threat analysis to enhance the SOC efficiency.",
              image:
                speaker_eric_de_bressing,
            },
            {
              firstName: "Thomas",
              lastName: "Cueni",
              title: 
                "Senior Security Engineer",
              description:
                "Tenable One is an exposure management platform that helps security leaders predict the consequences of a cyberattack by providing an understanding of the relationships between assets, exposures, permissions and threats along an attack path. The platform combines broad exposure coverage for IT, OT and IoT assets, cloud resources, containers, web apps and identity platforms with threat intelligence and data science from Tenable Research. With the Cloud Native Application Protection Platform (CNAPP) integrated into Tenable One, users can keep an eye on and secure all cloud assets in multi-cloud environments. From complete asset discovery and in-depth risk analysis to compliance, Tenable Cloud Security automates complex security workflows through meaningful visualization and step-by-step recommendations. With a comprehensive understanding of identities and infrastructure dependencies, the solution uncovers, prioritizes and remediates security gaps, helping to reduce your cloud attack surface and enforce the principle of least privilege at scale.",
              image:
                speaker_thomas_cueni,
            },
            {
              firstName: "Martin",
              lastName: "de Jongh",
              title: "Director GTM Engineering EMEA",
              description:
                "In this technical live demonstration, see how the world’s most advanced cybersecurity AI from SentinelOne can turn your organization’s data into its strongest defense. Scale autonomous protection across the enterprise with patent-pending AI technology. Simplify the Complex - Streamline investigations by intelligently combining common tools, synthesizing threat intelligence and contextual insights into a single conversational user experience. Uplevel Every Analyst - Find hidden risk, conduct deeper investigations, and respond faster—all in natural language. Train analysts with power query translations from natural language prompts. Accelerate SecOps - Advance your SecOps with our hunting quick starts, AI-powered analyses, auto-summaries, and suggested queries. Collaborate on investigations with shareable notebooks. Safeguard Your Data - Leverage a solution designed for data protection and privacy. Purple AI is never trained with customer data and is architected with the highest level of safeguards.",
              image:
              speaker_martin_de_jongh,
            },
            {
              firstName: "Detlev",
              lastName: "Narr",
              title: "Senior Consultant Threat Intelligence",
              description:
                "Threat Intelligence Services provide access to all information required to defend against cyber threats. They are provided by the world’s leading teams of researchers and analysts. There are a wide range of services that can be used for the respective use cases. From reporting and Darkweb monitoring to threat look-up and data feeds, there are many different possibilities. Threat intelligence provides a comprehensive overview of the global threat landscape by combining threat intelligence data, threat data feeds and proprietary investigations by vendors to support companies in the fight against cyber threats.",
              image:
                speaker_detlev_narr,
            },
            {
              firstName: "Patrick",
              lastName: "Buchholz",
              title: "Distribution & Channel Manager",
              description:
                "Generative AI, an emerging technology, enables machines to generate human-like content such as images, text and even human voices. The novelty here is not that AI-generated content has a special quality or would replace human experts, but that AI tools enable the incapable to become mediocre. This is precisely why this technology offers enormous mass potential for creative applications, but also for potential abuses.",
              image:
                speaker_patrick_buchholz,
            },
            {
              firstName: "Marcel",
              lastName: "Zumbühl",
              title: "CISO Post",
              description:
                "Current threat level, activities and actors. Crisis preparedness: how is Swiss Post preparing for an incident? What mitigating measures are in place at organizational and process level?",
              image:
                speaker_marcel_zumbuehl,
            },
            {
              firstName: "Gilles",
              lastName: "Peter",
              title: "Territory Manager Suisse",
              description:
                "",
              image:
                speaker_unknown,
            }
          ]}
        />
        */}
      </section>}
      {/*
      <Sponsors
        style={{ marginTop: "120px" }}
        logos={[
          [vectra_logo],
          [tenable],
          [c2sec_logo, cribl_logo, karspersky_logo, menlo_logo, one_identity_logo, splunk_logo, knowbe4_logo],
          [airlock_logo]
        ]}
      />
      */}
      <section>
        <Organizers
          organizers={[
            { src: post_logo, name: "Swiss Post Cybersecurity" }
          ]}
        />
      </section>
{       <ImageCarousel
        images={[
          eventFormatPhoto,
          "/img/21efdf712cf79fbd148856011f58bc6e.jpeg",
          "/img/2205cda10dfebc8d1ca3a5bbf2f8515e.jpeg",
          "/img/a7dc9838a6d79336be95edcbb10943c9.jpeg",
          "/img/c67f653b353385bcc7e424359aa6b3e8.jpeg",
          "/img/d6b45f79c4a62172598e9531d0587924.jpeg"
        ]}
        borderRadius="20px"
        height="284px"
        width="90%"
      /> }
      <section>
        <VideoSection
          video="https://vimeo.com/225843060"
          title="Genev'Hack"
          registerUrl="https://infomaniak.events/en-ch/conferences/genevhack-2025/90096f3d-505f-44b2-bbe2-192861842b67/event/1370148"
          image={video_image}
        />
      </section>
    </div>
  );
}

const styles = {
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    background: "linear-gradient(90deg, #FFF 27.78%, #E1E1E1 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontFamily: "Poppins",
    fontSize: `${window.outerWidth < 768 ? "12vw" : "5vw"}`,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    margin: 0,
  },
  subtitle: {
    fontFamily: "Arvo",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    marginTop: "-18px",
    textAlign: "center" as "center",
  },
};
